import {
  Flex, Layout, Space, Typography
} from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Background from "../Background";
import Logo from "../Logo";

import image1 from "./Variant1.png";
import image2 from "./Variant2.png";
import classes from "./matchingProcess.module.css";
import useLocalStorage from "../../hooks/useLocalStorage";
import { MATCHING_DONE } from "../../constants/storage";
import { appRoutes } from "../../constants/routes";

import { PROCESS_MATCHING_TIME } from "../../constants/app";

const { Title } = Typography;
const { Content } = Layout;

const MatchingProcess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setStorageItem } = useLocalStorage();

  useEffect(() => {
    const time = PROCESS_MATCHING_TIME ? parseInt(PROCESS_MATCHING_TIME, 10) : 5000;

    const navigateTimer = setTimeout(() => navigate(appRoutes.signUp), time);
    setStorageItem(MATCHING_DONE, true);

    return () => {
      clearTimeout(navigateTimer);
    };
  }, []);

  return (
    <Layout style={{ height: "100%", minHeight: "100vh" }}>
      <div className={classes.animation}>
        <img src={image1} className={classes.image1} alt="image1"/>
        <img src={image2} className={classes.image2} alt="image2"/>
      </div>
      <Background step={5}/>
      <Content className={classes.content}>
        <Flex vertical gap={16} align="center" style={{ textAlign: "center", maxWidth: "454px" }}>
          <Space>
            <Logo/>
          </Space>
          <Title level={2}>{t("survey.matchingProgressTitle")}</Title>
          <span className={classes.loadingIcon}>
            <span />
            <span />
            <span />
          </span>
        </Flex>
      </Content>
    </Layout>
  );
};

export default MatchingProcess;
